<script>

import request from "./request.vue";
import { format } from "date-fns";

const lgpdSchema = [
    {
        name: "name",
        displayName: "Nome",
        kind: "text",
        validation: "required",
        placeholder: "Digite o nome",
        defaultSort: true,
        notInFilters: false,
        search: {
            show: true,
            endWildcard: true,
            startWildcard: true,
        },
    },
    {
        name: "email",
        displayName: "Email",
        kind: "text",
        validation: "",
        notInFilters: false,
        placeholder: "Digite o email",
        search: {
            show: true,
            endWildcard: true,
            startWildcard: true,
        },
    },
    {
        name: "register",
        displayName: "Matrícula",
        kind: "text",
        validation: "",
        placeholder: "",
        notInFilters: true,
        search: {
            show: true,
            endWildcard: true,
            startWildcard: true,
        },
    },
    {
        name: "creationDate",
        displayName: "Data do cadastro",
        kind: "text",
        validation: "",
        placeholder: "",
        readOnly: true,
        formatter: value => format(value, "DD/MM/YYYY HH:mm"),
        creationHidden: true,
        notInFilters: true,
        search: {
            show: true,
            endWildcard: true,
            startWildcard: true,
        },
    },
    {
        name: "platform",
        displayName: "Plataforma",
        kind: "select",
        validation: "",
        placeholder: "",
        readOnly: true,
        notInFilters: true,
        formatter: value => value ? value : "WEB",
        options: [
            {
                name: "WEB",
                value: "WEB",
            },
            {
                name: "APP",
                value: "APP",
            }
        ],
        search: {
            show: true,
        }
    },
    {
        name: "id",
        displayName: "Código",
        kind: "text",
        validation: "",
        placeholder: "Digite o código do usuário",
        defaultSort: true,
        notInFilters: true,
        readOnly: true,
        search: {
            show: true,
            endWildcard: true,
            startWildcard: true,
        },
    },
    {
        name: "company",
        displayName: "Empresa",
        kind: "text",
        validation: "",
        placeholder: "Digite o código do usuário",
        defaultSort: true,
        readOnly: true,
        formatter: value => value ? value.name : "Sem empresa",
        creationHidden: true,
        notInFilters: true,
        search: {
            show: true,
            endWildcard: true,
            startWildcard: true,
        },
    },
    {
        name: "lastLogin",
        displayName: "Último acesso",
        kind: "text",
        validation: "",
        placeholder: "",
        readOnly: true,
        formatter: value => format(value, "DD/MM/YYYY HH:mm"),
        creationHidden: true,
        notInFilters: true,
        search: {
            show: true,
        },
    },
];


export default {
    getInfo: async function (id) {
        const response = await request.send("user", "getInfo", { id }, true);
        return response.data;
    },
    updateInfo: async function (userData) {
        const response = await request.send("user", "updateInfo", userData, true);
        return response.data;
    },
    search: async function (parameters) {
        const response = await request.send("user", "search", parameters, true);
        return response;
    },
    getSchema: function () {
        return lgpdSchema;
    },
    lgpdAnonimize: async function (id) {
        const data = {id}
        return request.send("user", "lgpd/update", data, true)
    },
}


</script>